import { render, staticRenderFns } from "./Temperatures.vue?vue&type=template&id=85afb76e"
import script from "./Temperatures.vue?vue&type=script&lang=js"
export * from "./Temperatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports